<template>
  <v-overlay
    :model-value="show"
    :absolute="absolute"
    class="justify-center"
    persistent>
    <div class="progress-container">
      <v-progress-circular
        v-if="showProgressCircle"
        indeterminate
        size="64"
        width="6"
        color="primary-lighten-3" />
      <div v-if="message" class="message">{{ message }}</div>
    </div>
  </v-overlay>
</template>

<script>
export default {
  name: "Loader",
  props: {
    show: { type: Boolean, required: true },
    message: { type: String, required: false, default: undefined },
    absolute: { type: Boolean, default: false },
    showProgressCircle: { type: Boolean, default: true },
  },
};
</script>

<style scoped lang="scss">
.progress-container {
  position: fixed;
  top: 50vh;
  .message {
    padding-top: 14px;
    text-align: center;
    width: 40vw;
    color: rgb(var(--v-theme-primary));
  }
}
</style>
